import { createContext } from "react"

 const VolunteerListContext = createContext();

 export default VolunteerListContext;